import { createSelector } from "reselect";

const selectSite = (state) => state.site;

export const selectActiveLink = createSelector(
	[selectSite],
	(site) => site.activeLink
);
export const selectShowMenu = createSelector(
	[selectSite],
	(site) => site.showMenu
);
export const selectLoaded = createSelector([selectSite], (site) => site.loaded);
export const selectToggleModalIos = createSelector(
	[selectSite],
	(site) => site.modalIos
);
export const selectToggleSignForm = createSelector(
	[selectSite],
	(site) => site.signFrom
);
export const selectProvince = createSelector(
	[selectSite],
	(site) => site.Province
);
export const selectCities = createSelector([selectSite], (site) => site.cities);
export const selectLatlng = createSelector([selectSite], (site) => site.latLng);
export const selectMarkerLayer = createSelector(
	[selectSite],
	(site) => site.latLng
);
export const selectTecOrAttr = createSelector(
	[selectSite],
	(site) => site.tecOrAttr
);

export const selectSelectedProduct = createSelector(
	[selectSite],
	(site) => site.product
);

export const selectProducts = createSelector(
	[selectSite],
	(site) => site.products
);
export const selectAccessories = createSelector(
	[selectSite],
	(site) => site.accessories
);
export const selectSelectedAccessory = createSelector(
	[selectSite],
	(site) => site.accessory
);

export const selectInfo = createSelector([selectSite], (site) => site.info);

export const selectAboutUs = createSelector(
	[selectSite],
	(site) => site.aboutUs
);

export const selectBaseInfo = createSelector(
	[selectSite],
	(site) => site.baseInfo
);

export const selectEducation = createSelector(
	[selectSite],
	(site) => site.education
);

export const selectCountUp = createSelector(
	[selectSite],
	(site) => site.countUp
);
export const selectNearest = createSelector(
	[selectSite],
	(site) => site.nearest
);
export const selectListProvince = createSelector(
	[selectSite],
	(site) => site.listProvince
);
export const selectApplication = createSelector(
	[selectSite],
	(site) => site.application
);
export const selectNews = createSelector([selectSite], (site) => site.news);
export const selectSlider = createSelector([selectSite], (site) => site.slider);
export const selectTrackSystem = createSelector(
	[selectSite],
	(site) => site.trackSystem
);
